import SystemUtil from 'lib/SystemUtil'

Component({
  /**
   * 组件的属性列表
   */
  properties: {
    cardData: {
      type: Object,
      value: {}
    },
    isNew: {
      type: Boolean,
      value: false
    }
  },
  /**
   * 组件的初始数据
   */
  data: {},

  ready: function () {
    console.log("this data ---->", this.data);

    // 自动跳转
    if (SystemUtil.isImPage() && this.data.isNew && this.data.cardData.auto) {
      this.doJump();
    }
  },

  /**
   * 组件的方法列表
   */
  methods: {
    isUrlValid: function (url) {
      return (
        url.indexOf("http://") === 0 || url.indexOf("https://") === 0
      );
    },
    /**
     * 跳转卡片页面
     */
    doJump: function () {
      const {
        expireDate,
        xcx = '',
        h5,
      } = this.data.cardData;
      if (expireDate && new Date() > new Date(Number(expireDate))) {
        wx.showToast({
          title: "该卡片已过期",
          icon: "none",
          duration: 2000
        });
        return;
      }
      const url = h5
      if (xcx) {
        const xcxUrl = xcx.replace('xcx://xcx', '')
        wx.navigateTo({
          url: xcxUrl
        });
      } else if (url && this.isUrlValid(url)) {
        wx.navigateTo({
          url: `/pages/bridge/webview/index?url=${encodeURIComponent(url)}`
        });
      } else {
        wx.showToast({
          title: "暂不支持的功能",
          icon: "none",
          duration: 2000
        });
      }
    }
  }
});
